export default "__VITE_ASSET__CrahYHf$__"